import React, { useState } from 'react';
import './SignUpForm.css';
import config from "../config";  // adjust the path as needed


const LoginForm = ({ onLoginSuccess }) => {
  const [formData, setFormData] = useState({ mobile: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);
  //   try {
  //     // const response = await fetch('/api/user-login/', {
  //     const response = await fetch('http://127.0.0.1:8000/api/user-login/', {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify(formData),
  //     });
  //     const data = await response.json();
  //     setLoading(false);
  //     if (response.ok) {
  //       setMessage('Login successful!');
  //       if (onLoginSuccess) onLoginSuccess();
  //     } else {
  //       setMessage(data.error || 'Login failed!');
  //     }
  //   } catch {
  //     setLoading(false);
  //     setMessage('Network error!');
  //   }
  // };






const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setMessage('');

  try {
    // const response = await fetch('http://127.0.0.1:8000/api/user-login/', {
    const response = await fetch(`${config.API_BASE_URL}api/user-login/`, {
    // const response = await fetch('https://dseapi.sadhanlab.com/api/user-login/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    });

    const data = await response.json();
    setLoading(false);

  //   if (response.ok && data.token) {
  //     localStorage.setItem("token", data.token);
  //     setMessage('Login successful!');
  //     if (onLoginSuccess) onLoginSuccess();
  //  }

if (response.ok && data.token) {

  // console.log("its workinjg")
  
  localStorage.setItem("token", data.token);
  localStorage.setItem("username", data.username);  // ✅ store username
  setMessage('Login successful!');
  if (onLoginSuccess) onLoginSuccess();
  window.location.reload();  // ✅ reloads, so Header picks up username

}



  else {
      setMessage(data.message || 'Login failed!');
    }
  } catch (error) {
    setLoading(false);
    setMessage('Network error!');
    console.error("Full Login Error:", error);
  }
};



  






  return (
    <>
<form
  className="sign-up-form"
  onSubmit={handleSubmit}
  style={{ margin: 'auto' }} // <-- explicitly declare margin auto
>
  <h2>Login</h2>
  <input
    type="tel"
    name="mobile"
    placeholder="Mobile Number"
    value={formData.mobile}
    onChange={handleChange}
    required
  />
  <input
    type="password"
    name="password"
    placeholder="Password"
    value={formData.password}
    onChange={handleChange}
    required
  />
  <button type="submit" disabled={loading}>
    {loading ? 'Logging in...' : 'Login'}
  </button>
  {message && <p>{message}</p>}

</form>

  {/* <a href="http://127.0.0.1:8000/api/user-registration/" target="_blank" rel="noopener noreferrer"> */}
  {/* <a href="https://dseapi.sadhanlab.com/api/user-registration/" target="_blank" rel="noopener noreferrer"> */}
<a
  // href={`${config.API_BASE_URL}api/user-registration/`}
  // target="_blank"
    href="/RegistrationForm"

  rel="noopener noreferrer"
>
    Sign Up/ Reset Password
  </a>



</>
  );
};

export default LoginForm;
